<template>
  <div>
    <form class="columns is-multiline" @submit="onNextStep">
      <div class="column is-12">
        <div class="box">
          <div class="columns is-multiline">
            <div class="column is-12 is-paddingless">
              <h1>Escribe sobre el producto</h1>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Título</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="title"
                    placeholder="iPhone/Samsung en buen estado"
                    name="title"
                    :class="{ 'is-danger': vverrors.first('title') }"
                    v-validate="'required'"
                  >
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">Descripción</label>
                <div class="control">
                  <textarea
                    class="input text-area-height"
                    type="text"
                    v-model="description"
                    placeholder="Descripción del smartphone o dispositivo que vas a vender. Entre más atractivo, mucho mejor."
                    name="description"
                    :class="{ 'is-danger': vverrors.first('description') }"
                    v-validate="'required'"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <h1>Categoría</h1>
            </div>
            <template v-for="(category, index) of filteredCategoriesList">
              <div class="column is-2" :key= "index">
                <div class="list-category">
                  <label class="label">{{category.categoryFather}}</label>
                  <template v-for="(item, ind) of category.categoriesList">
                    <div class="category" :key="ind" v-if="item.id === 12 || item.id === 40">
                      <label class="checkbox" :class="{'has-text-danger': isErrorCatagories}">
                        <input
                          type="checkbox"
                          @click="addCategory(item.id)"
                          :checked="categoriesSelected.find(option => option === item.id)"
                        >
                        {{item.name}}
                      </label>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            <div class="column is-12 is-paddingless">
              <h1>Marca y Modelo</h1>
            </div>

            <div class="column is-6">
              <div class="field">
                <label class="label">Marca</label>
                <div class="select is-fullwidth" :class="{ 'is-danger': vverrors.first('brand') }">
                  <select name="brand" v-model="brand" v-validate="'required|excluded:-1'" @change="onChangeBrand">
                    <option :value="null" disabled>Seleccione una opción</option>
                    <option v-for="brandObj in catalogBrandsList" :value="brandObj.id" :key="brandObj.id">
                      {{ brandObj.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="column is-6">
              <div class="field">
                <label class="label">Modelo</label>
                <div class="select is-fullwidth" :class="{ 'is-danger': vverrors.first('model') }">
                  <select name="model" v-model="model" v-validate="'required|excluded:-1'">
                    <option :value="null" disabled>Seleccione una opción</option>
                    <option v-for="modelObj in catalogModelsList" :value="modelObj.id" :key="modelObj.id">
                      {{ modelObj.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-11 is-paddingless">
              <h1>Características</h1>
            </div>
            <template v-for="(characteristic) of characteristicsSelected">
              <div class="column is-4" :key="characteristic.name">
                <div class="field">
                  <label class="label">{{characteristic.name}}</label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      :value="characteristic.value"
                      :name="characteristic.name"
                      @input="setValueCharacteristic($event.target)"
                      :class="{ 'is-danger': vverrors.first(characteristic.name) }"
                      v-validate="'required'"
                    >
                  </div>
                </div>
              </div>
            </template>
            <div class="column is-12 is-paddingless">
              <h1>Valor estimado</h1>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Precio</label>
                <div class="control">
                  <input
                    class="input"
                    type="number"
                    v-model="price"
                    placeholder="0.00"
                    name="price"
                    :class="{ 'is-danger': vverrors.first('price') }"
                    v-validate="'required|regex:^[0-9]+'"
                  >
                </div>
              </div>
              <!-- <p>Recuerda que cada GIV equivale a $1 MXN.</p> -->
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Condición</label>
                <div class="select is-fullwidth" :class="{ 'is-danger': vverrors.first('condition') }">
                  <select
                    name="condition"
                    v-model="condition"
                    v-validate="'required|excluded:-1'"
                  >
                    <option :value="null" disabled>Seleccione una opción</option>
                    <option :value="1"> Nuevo</option>
                    <option :value="2"> Seminuevo</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Lugar de deposito</label>
                <div class="select is-fullwidth" :class="{ 'is-danger': vverrors.first('placeDeposit') }">
                  <select
                    name="placeDeposit"
                    v-model="placeDeposit"
                    v-validate="'required|excluded:-1'"
                  >
                    <option :value="null" disabled>Seleccione una opción</option>
                    <option :value="1"> Recolección a domicilio</option>
                    <option :value="2"> WeWork Montes Úrales</option>
                    <option :value="2"> German Centre  Av. Santa Fe 170</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Stock</label>
                <div class="control">
                  <input
                    class="input"
                    type="number"
                    v-model="stock"
                    placeholder="1"
                    name="stock"
                    :class="{ 'is-danger': vverrors.first('stock') }"
                    v-validate="'required|regex:^[0-9]+'"
                  >
                </div>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <h1>Extras</h1>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">¿Cuenta con caja original?</label>
                <div class="select is-fullwidth" :class="{ 'is-danger': vverrors.first('box') }">
                  <select
                    name="box"
                    v-model="box"
                    v-validate="'required|excluded:-1'"
                  >
                    <option :value="null" disabled>Seleccione una opción</option>
                    <option :value="true"> Si</option>
                    <option :value="false"> No</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">¿Cuenta con accesorios originales(cargador y cable)?</label>
                <div class="select is-fullwidth" :class="{ 'is-danger': vverrors.first('accessories') }">
                  <select
                    name="accessories"
                    v-model="accessories"
                    v-validate="'required|excluded:-1'"
                  >
                    <option :value="null" disabled>Seleccione una opción</option>
                    <option :value="true"> Si</option>
                    <option :value="false"> No</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label">¿Publicar en tienda WooCommerce?</label>
                <div class="select is-fullwidth" :class="{ 'is-danger': vverrors.first('publishInWoo') }">
                  <select
                    name="publishInWoo"
                    v-model="publishInWoo"
                    v-validate="'required|excluded:-1'"
                  >
                    <option :value="null" disabled>Seleccione una opción</option>
                    <option :value="true"> Si</option>
                    <option :value="false"> No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="columns is-multiline is-pulled-centered padding-top-20">
          <div class="column is-12 has-text-right">
            <button
              class="button button-givu"
              type="submit"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </form>
    <modal-add-characteristic
      v-if="modalAddCharacteristic"
      :close="showModalAddChatacteristic"
      :catalogCharacteristicsList="catalogCharacteristicsList"
      :characteristicsSelected="characteristicsSelected"
      :saveCharacteristic="saveCharacteristic"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'General',
  components: {
    modalAddCharacteristic: () => import('@/components/NewProduct/ModalAddCharacteristic.vue')
  },
  async mounted () {
    this.title = this._title
    this.description = this._description
    this.price = this._price
    this.condition = this._condition
    this.placeDeposit = this._placeDeposit
    this.stock = this._stock
    this.box = this._box
    this.accessories = this._accessories
    this.brand = this._brand
    if (this.brand) {
      this.catalogModelsList = await this.getModelsProduct(this.brand)
    }
    this.model = this._model
    this.categoriesSelected = this._categoriesSelected
    this.characteristicsSelected = this.characteristicsSelected
    this.publishInWoo = this._publishInWoo ?? null
  },
  data () {
    return {
      title: '',
      description: '',
      price: '',
      condition: null,
      placeDeposit: null,
      stock: '',
      box: null,
      accessories: null,
      publishInWoo: null,
      brand: 0,
      model: 0,
      catalogBrandsList: [],
      catalogModelsList: [],
      catalogCategoriesList: [],
      categoriesSelected: [],
      catalogCharacteristicsList: [],
      characteristicsSelected: [
        {
          'id': 3,
          'name': 'Tamaño / Capacidad'
        },
        {
          'id': 1,
          'name': 'Color'
        }
      ],
      modalAddCharacteristic: false,
      isErrorCatagories: false,
      isErrorCharacteristics: false,
      isLoading: true,
      'models': [
        {
          'id': 63,
          'name': 'iPhone 16',
          'brand_id': 2,
          'created_at': '2025-06-05T19:30:40.441Z',
          'updated_at': '2025-06-05T19:30:40.441Z',
          'active': true
        },
        {
          'id': 62,
          'name': 'iPhone 16 Plus',
          'brand_id': 2,
          'created_at': '2025-06-05T19:30:40.441Z',
          'updated_at': '2025-06-05T19:30:40.441Z',
          'active': true
        },
        {
          'id': 61,
          'name': 'iPhone 16 Pro',
          'brand_id': 2,
          'created_at': '2025-06-05T19:30:40.441Z',
          'updated_at': '2025-06-05T19:30:40.441Z',
          'active': true
        },
        {
          'id': 60,
          'name': 'iPhone 16 Pro Max',
          'brand_id': 2,
          'created_at': '2025-06-05T19:30:40.441Z',
          'updated_at': '2025-06-05T19:30:40.441Z',
          'active': true
        },
        {
          'id': 59,
          'name': 'Galaxy S25+',
          'brand_id': 1,
          'created_at': '2025-05-02T19:50:36.164Z',
          'updated_at': '2025-05-02T19:50:36.164Z',
          'active': true
        },
        {
          'id': 58,
          'name': 'Galaxy S25',
          'brand_id': 1,
          'created_at': '2025-05-02T19:50:24.297Z',
          'updated_at': '2025-05-02T19:50:24.297Z',
          'active': true
        },
        {
          'id': 57,
          'name': 'iPhone 14 Plus',
          'brand_id': 2,
          'created_at': '2025-04-25T22:00:49.935Z',
          'updated_at': '2025-04-25T22:00:49.935Z',
          'active': true
        },
        {
          'id': 56,
          'name': 'iPhone 15 Plus',
          'brand_id': 2,
          'created_at': '2025-04-25T22:00:34.888Z',
          'updated_at': '2025-04-25T22:00:34.888Z',
          'active': true
        },
        {
          'id': 51,
          'name': 'Galaxy S25 Ultra',
          'brand_id': 1,
          'created_at': '2025-03-19T15:48:36.918Z',
          'updated_at': '2025-03-19T15:48:36.918Z',
          'active': true
        },
        {
          'id': 49,
          'name': 'Galaxy Z Flip6',
          'brand_id': 1,
          'created_at': '2025-03-19T15:48:36.918Z',
          'updated_at': '2025-03-19T15:48:36.918Z',
          'active': true
        },
        {
          'id': 46,
          'name': 'Galaxy Z Fold6',
          'brand_id': 1,
          'created_at': '2025-03-19T15:48:36.918Z',
          'updated_at': '2025-03-19T15:48:36.918Z',
          'active': true
        },
        {
          'id': 45,
          'name': 'V60 ThinQ 5G',
          'brand_id': 3,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 44,
          'name': 'iPhone 11',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 43,
          'name': 'Galaxy S24 Ultra',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 42,
          'name': 'Galaxy S24+',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 41,
          'name': 'Galaxy S24',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 40,
          'name': 'Galaxy Z Flip 5',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 39,
          'name': 'Galaxy Z Fold 5',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 38,
          'name': 'Galaxy S23 Ultra',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 37,
          'name': 'Galaxy S23+',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 36,
          'name': 'Galaxy S23',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 35,
          'name': 'Galaxy Z Flip 4',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 34,
          'name': 'Galaxy Z Fold 4',
          'brand_id': 1,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 33,
          'name': 'iPhone 15 Pro Max',
          'brand_id': 2,
          'created_at': '2024-03-06T19:36:10.328Z',
          'updated_at': '2024-03-06T19:36:10.328Z',
          'active': true
        },
        {
          'id': 32,
          'name': 'iPhone 15 Pro',
          'brand_id': 2,
          'created_at': '2024-03-06T19:36:10.238Z',
          'updated_at': '2024-03-06T19:36:10.238Z',
          'active': true
        },
        {
          'id': 31,
          'name': 'iPhone 15 Mini',
          'brand_id': 2,
          'created_at': '2024-03-06T19:36:10.143Z',
          'updated_at': '2024-03-06T19:36:10.143Z',
          'active': true
        },
        {
          'id': 30,
          'name': 'iPhone 15',
          'brand_id': 2,
          'created_at': '2024-03-06T19:36:10.054Z',
          'updated_at': '2024-03-06T19:36:10.054Z',
          'active': true
        },
        {
          'id': 25,
          'name': 'Galaxy Z Flip 3',
          'brand_id': 1,
          'created_at': '2023-10-06T20:16:25.200Z',
          'updated_at': '2023-10-06T20:16:25.200Z',
          'active': true
        },
        {
          'id': 24,
          'name': 'Galaxy Z Fold 3',
          'brand_id': 1,
          'created_at': '2023-10-06T20:16:25.200Z',
          'updated_at': '2023-10-06T20:16:25.200Z',
          'active': true
        },
        {
          'id': 20,
          'name': 'iPhone 14 Pro Max',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 19,
          'name': 'iPhone 14 Pro',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 18,
          'name': 'iPhone 14',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 17,
          'name': 'iPhone 14 Mini',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 16,
          'name': 'iPhone 13 Pro Max',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 15,
          'name': 'iPhone 13 Pro',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 14,
          'name': 'iPhone 13',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 13,
          'name': 'iPhone 13 Mini',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 12,
          'name': 'iPhone 12 Pro Max',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 11,
          'name': 'iPhone 12 Pro',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 10,
          'name': 'iPhone 12',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        },
        {
          'id': 9,
          'name': 'iPhone 12 Mini',
          'brand_id': 2,
          'created_at': '2023-10-06T20:13:48.427Z',
          'updated_at': '2023-10-06T20:13:48.427Z',
          'active': true
        }
      ]
    }
  },
  async beforeMount () {
    let responseCategories = await this.getCategoriesProduct()
    let responseCharacteristics = await this.getCharacteristicsProduct()
    let responseBrands = await this.getBrandsProduct()
    this.catalogCategoriesList = responseCategories
    this.catalogCharacteristicsList = responseCharacteristics
    this.catalogBrandsList = responseBrands
    this.isLoading = false
    console.log(this.catalogCharacteristicsList, 'categorias')
  },
  computed: {
    ...mapState({
      _title: state => state.newProduct.title,
      _description: state => state.newProduct.description,
      _price: state => state.newProduct.price,
      _condition: state => state.newProduct.condition,
      _placeDeposit: state => state.newProduct.placeDeposit,
      _stock: state => state.newProduct.stock,
      _box: state => state.newProduct.box,
      _accessories: state => state.newProduct.accessories,
      _model: state => state.newProduct.model,
      _brand: state => state.newProduct.brand,
      _categoriesSelected: state => state.newProduct.categoriesSelected,
      _characteristicsSelected: state => state.newProduct.characteristicsSelected,
      _publishInWoo: state => state.newProduct.publishInWoo
    }),
    filteredCategoriesList () {
      return this.catalogCategoriesList.filter(this.categoryContainsAllowedItems)
    }
  },
  methods: {
    ...mapMutations(['updateStepNewProduct', 'setNewProductValues']),
    ...mapActions(['getCategoriesProduct', 'getCharacteristicsProduct', 'getBrandsProduct', 'getModelsProduct']),
    async onChangeBrand () {
      this.model = null
      this.catalogModelsList = []
      if (this.brand) {
        this.catalogModelsList = await this.getModelsProduct(this.brand)
      }
    },
    categoryContainsAllowedItems (category) {
      return category.categoriesList.some(item => item.id === 12 || item.id === 40)
    },
    addCategory (id) {
      let isExist = this.categoriesSelected.find(item => item === id)
      if (isExist) {
        let removeCategory = this.categoriesSelected.filter(item => item !== id)
        this.categoriesSelected = removeCategory
      } else {
        this.categoriesSelected = [...this.categoriesSelected, id]
      }
      this.isErrorCatagories = false
    },
    showModalAddChatacteristic () {
      this.modalAddCharacteristic = !this.modalAddCharacteristic
      this.isErrorCharacteristics = false
    },
    saveCharacteristic (characteristic) {
      this.characteristicsSelected = characteristic
      this.showModalAddChatacteristic()
    },
    setValueCharacteristic (target, name) {
      this.characteristicsSelected = this.characteristicsSelected.map(item => {
        if (item.name === target.name) item.value = target.value
        return item
      })
    },
    onStepBack () {
      this.updateStepNewProduct(1)
    },
    async onNextStep (e) {
      e.preventDefault()
      console.log(this.placeDeposit)
      if (await this.$validator.validateAll()) {
        this.setNewProductValues({
          title: this.title,
          description: this.description,
          model: this.model,
          brand: this.brand,
          price: this.price,
          box: this.box,
          accessories: this.accessories,
          condition: this.condition,
          placeDeposit: this.placeDeposit,
          stock: this.stock,
          categoriesSelected: this.categoriesSelected,
          characteristicsSelected: this.characteristicsSelected,
          publishInWoo: this.publishInWoo
        })
        if (!this.categoriesSelected.length || !this.characteristicsSelected.length) {
          if (!this.categoriesSelected.length) this.isErrorCatagories = true
          if (!this.characteristicsSelected.length) this.isErrorCharacteristics = true
          return true
        }
        this.updateStepNewProduct(2)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .text-area-height {
    height: 100px;
  }
  h1 {
    border-bottom: 1px solid #cd3d27;
    padding-bottom: 0.3rem;
    margin-bottom: 0.5rem;
  }
  .list-category {
    border-radius: 5px;
    width: 120%;
    border: 1px solid #292A30;
    padding: 0;
    .label {
      padding: 0.4rem;
      font-size: 12px;
      text-align: center;
      background: #292A30;
      color: #fff;
      border-bottom: #292A30 1px solid;
    }
    .category {
      padding: 0.3rem;
      font-size: 12px;
    }
  }
</style>
